import { AnyAction } from 'redux';
import { Draft, SharingDraft } from '@/types';
import { isDraftDesignConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { getCleanDraft } from '@/model/draft/getCleanDraft';
import { getViewForPreview } from '@/model/draft/getViewForPreview';
import { getSharingDraft } from '@/model/draftMapper/getSharingDraft';
import { isSharingDraftDesignConfiguration } from '@/model/draftMapper/utils/isSharingDraftConfigurationType';
import { DraftDispatch } from '@/redux/draft/draftDispatch';
import { Thunk } from '@/redux/types';
import { setFilterDesignIdAction } from '@/components/draft/draftState/actions/setFilterDesignIdAction';
import { withoutHistory } from '@/components/draft/draftState/history/withoutHistory';

const saveFilterDesignId = (draft: Draft, sharingDraft: SharingDraft, dispatch: DraftDispatch) => {
  const { configurationIds, configurations } = draft;
  configurationIds.forEach((configurationId, configurationIndex) => {
    const configuration = configurations[configurationId];
    const sharingDraftConfiguration = sharingDraft.configurations[configurationIndex];
    if (
      isDraftDesignConfiguration(configuration) &&
      configuration.filter &&
      isSharingDraftDesignConfiguration(sharingDraftConfiguration)
    ) {
      const designId = sharingDraftConfiguration.filter?.designId;
      if (designId) {
        dispatch(withoutHistory(setFilterDesignIdAction(configuration, designId)));
      }
    }
  });
};

const setPreviewViewId = (draft: Draft, sharingDraft: SharingDraft) => {
  const previewView = getViewForPreview(draft);
  sharingDraft.viewId = previewView.id;
};

export const saveDraftAction =
  <SaveMethodReturnType>(
    draft: Draft,
    saveMethod: (
      sharingDraft: SharingDraft
    ) => SaveMethodReturnType | Promise<SaveMethodReturnType>,
    progressCallback?: () => void
  ): Thunk<Promise<SaveMethodReturnType>, AnyAction> =>
  async (dispatch, getState) => {
    const { draftDispatch } = getState();
    const cleanedDraft = getCleanDraft(draft, draftDispatch);
    const sharingDraft = await getSharingDraft(cleanedDraft, progressCallback);
    saveFilterDesignId(draft, sharingDraft, draftDispatch);
    setPreviewViewId(draft, sharingDraft);

    return saveMethod(sharingDraft);
  };
